import { proxyBE } from './common';

export const blogService = {

    articleCount(slug, section) {
        return proxyBE.get(`blog/category-count/${slug}/${section}`);        
    },

    article(slug) {
        return proxyBE.get(`blog/article/${slug}`);
    },

    category(slug, section) {
        return proxyBE.get(`blog/category/${slug}/${section}`);                
    },

    lastArticles(numPage, dimPage, section) {
        return proxyBE.get(`blog/last-articles/${numPage}/${dimPage}/${section}`);                
    },

    topCategories() {
        return proxyBE.get(`blog/top-categories/`);        
    },

    topArticles(dimPage) {
        return proxyBE.get(`blog/top-articles/${dimPage}`);        
    },

    topFixedArticles(dimPage) {
        return proxyBE.get(`blog/topfixed-articles/${dimPage}`);        
    },

    lastArticlesByCat(slug, numPage, dimPage, section) {
       return proxyBE.get(`blog/last-cat-articles/${slug}/${numPage}/${dimPage}/${section}`);       
    },
}